module.exports = __webpack_public_path__ + "03_medium_gray.72d53df5.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/dad/layer5/03_medium_gray.png
// module id = 6l0L
// module chunks = 0